import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedBoardStateApiService } from './board-state-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class BoardStateApiService extends GeneratedBoardStateApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
